import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_tracks_card = _resolveComponent("the-tracks-card")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_TheFooter = _resolveComponent("TheFooter")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, { class: "center-container" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_content, {
        class: "center-div",
        style: { background: '#fff', padding: '85px 50px 50px 50px', margin: 0, minHeight: '720px' }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_the_tracks_card, { data: _ctx.tracks }, null, 8, ["data"])
        ]),
        _: 1
      }),
      _createVNode(_component_TheFooter)
    ]),
    _: 1
  }))
}